



export const timeAgo = (timestamp) => {
    const seconds = Math.floor((Date.now() / 1000) - timestamp);
    const intervals = {
        year: 31536000,
        month: 2592000,
        week: 604800,
        day: 86400,
        hour: 3600,
        minute: 60,
        second: 1
    };
    for (let unit in intervals) {
        const count = Math.floor(seconds / intervals[unit]);
        if (count >= 1) {
            return `${count} ${unit}${count > 1 ? 's' : ''}`;
        }
    }
    return 'just now';
}


export const getHostname = (url) => {
    try {
        const urlObj = new URL(url);
        return urlObj.hostname.replace(/^www\./, '');
    } catch (error) {
        // console.error("Error parsing URL:", error);
        return "";
    }
};

export const localStorageOrDefault = (key, defaultValue) => {
  const value = localStorage.getItem(key);
  return value !== null ? value : defaultValue;
}
